import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { MobileNav } from '../components/MobileNav';
export function WorkMirrorAppHome() {
  return <>
      <Helmet data-id="element-4842">
        <title data-id="element-4843">Mirror — Work Mirror | Lazy Monk Labs</title>
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-4844">
        <MobileNav data-id="element-4845" />

        {/* APP PAGE: Highest density, operational, compact */}
        <main className="pt-16 sm:pt-20 pb-8 sm:pb-12" data-id="element-4846">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-4847">
            {/* Compact header with status */}
            <div className="py-4 sm:py-5 border-b border-[#2B2B2B] flex items-center justify-between" data-id="element-4848">
              <div data-id="element-4849">
                <p className="text-xs font-mono text-gray-600 uppercase tracking-wider" data-id="element-4850">
                  Work Mirror
                </p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-4851">
                  Active • 3 entries logged
                </p>
              </div>
              <div className="flex items-center gap-2" data-id="element-4852">
                <span className="text-xs px-2 py-1 border border-[#2B2B2B] text-gray-500" data-id="element-4853">
                  Oscillation
                </span>
              </div>
            </div>

            {/* Main grid - 2 columns on desktop, stacked on mobile */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-5 mt-6 sm:mt-8" data-id="element-4854">
              {/* Left column - Actions */}
              <div className="lg:col-span-2 space-y-4 sm:space-y-5" data-id="element-4855">
                {/* Quick actions */}
                <div className="border border-[#2B2B2B] bg-[#0A0A0A]" data-id="element-4856">
                  <div className="p-4 sm:p-5 border-b border-[#2B2B2B]" data-id="element-4857">
                    <p className="text-xs font-mono text-gray-600 uppercase tracking-wider" data-id="element-4858">
                      Log
                    </p>
                  </div>
                  <div className="p-4 sm:p-5 space-y-3" data-id="element-4859">
                    <Link to="/mirrors/work/note" className="block w-full p-4 border border-[#2B2B2B] text-left hover:border-[#F5F5F5] hover:bg-[#F5F5F5]/5 transition-all" data-id="element-4860">
                      <p className="text-sm font-medium text-[#F5F5F5] mb-1" data-id="element-4861">
                        Note
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-4862">
                        Drop a thought without structure
                      </p>
                    </Link>

                    <Link to="/mirrors/work/decode-situation" className="block w-full p-4 border border-[#2B2B2B] text-left hover:border-[#F5F5F5] hover:bg-[#F5F5F5]/5 transition-all" data-id="element-4863">
                      <p className="text-sm font-medium text-[#F5F5F5] mb-1" data-id="element-4864">
                        Situation
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-4865">
                        Log a specific work moment
                      </p>
                    </Link>

                    <Link to="/mirrors/work/log-mode" className="block w-full p-4 border border-[#2B2B2B] text-left hover:border-[#F5F5F5] hover:bg-[#F5F5F5]/5 transition-all" data-id="element-4866">
                      <p className="text-sm font-medium text-[#F5F5F5] mb-1" data-id="element-4867">
                        Day
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-4868">
                        Log how today felt
                      </p>
                    </Link>
                  </div>
                </div>

                {/* Recent entries */}
                <div className="border border-[#2B2B2B] bg-[#0A0A0A]" data-id="element-4869">
                  <div className="p-4 sm:p-5 border-b border-[#2B2B2B]" data-id="element-4870">
                    <p className="text-xs font-mono text-gray-600 uppercase tracking-wider" data-id="element-4871">
                      Recent
                    </p>
                  </div>
                  <div className="divide-y divide-[#2B2B2B]" data-id="element-4872">
                    {/* Entry 1 */}
                    <div className="p-4 sm:p-5 hover:bg-[#F5F5F5]/5 transition-colors cursor-pointer" data-id="element-4873">
                      <div className="flex items-start justify-between gap-4 mb-2" data-id="element-4874">
                        <p className="text-sm text-[#F5F5F5]" data-id="element-4875">
                          Team meeting decision point
                        </p>
                        <span className="text-xs text-gray-600 whitespace-nowrap" data-id="element-4876">
                          2h ago
                        </span>
                      </div>
                      <p className="text-xs text-gray-500" data-id="element-4877">
                        Situation • Commitment vs Optionality
                      </p>
                    </div>

                    {/* Entry 2 */}
                    <div className="p-4 sm:p-5 hover:bg-[#F5F5F5]/5 transition-colors cursor-pointer" data-id="element-4878">
                      <div className="flex items-start justify-between gap-4 mb-2" data-id="element-4879">
                        <p className="text-sm text-[#F5F5F5]" data-id="element-4880">
                          Thursday work pattern
                        </p>
                        <span className="text-xs text-gray-600 whitespace-nowrap" data-id="element-4881">
                          1d ago
                        </span>
                      </div>
                      <p className="text-xs text-gray-500" data-id="element-4882">
                        Day • High tension
                      </p>
                    </div>

                    {/* Entry 3 */}
                    <div className="p-4 sm:p-5 hover:bg-[#F5F5F5]/5 transition-colors cursor-pointer" data-id="element-4883">
                      <div className="flex items-start justify-between gap-4 mb-2" data-id="element-4884">
                        <p className="text-sm text-[#F5F5F5]" data-id="element-4885">
                          Project scope discussion
                        </p>
                        <span className="text-xs text-gray-600 whitespace-nowrap" data-id="element-4886">
                          3d ago
                        </span>
                      </div>
                      <p className="text-xs text-gray-500" data-id="element-4887">
                        Situation • Freedom vs Structure
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right column - System state */}
              <div className="space-y-4 sm:space-y-5" data-id="element-4888">
                {/* Current pattern */}
                <div className="border border-[#2B2B2B] bg-[#0A0A0A] p-4 sm:p-5" data-id="element-4889">
                  <p className="text-xs font-mono text-gray-600 uppercase tracking-wider mb-3" data-id="element-4890">
                    Pattern
                  </p>
                  <p className="text-base font-medium text-[#F5F5F5] mb-2" data-id="element-4891">
                    Oscillation
                  </p>
                  <p className="text-xs text-gray-500 leading-relaxed" data-id="element-4892">
                    Moving between opposing pulls
                  </p>
                </div>

                {/* Active loops */}
                <div className="border border-[#2B2B2B] bg-[#0A0A0A]" data-id="element-4893">
                  <div className="p-4 sm:p-5 border-b border-[#2B2B2B]" data-id="element-4894">
                    <p className="text-xs font-mono text-gray-600 uppercase tracking-wider" data-id="element-4895">
                      Active Loops
                    </p>
                  </div>
                  <div className="p-4 sm:p-5 space-y-3" data-id="element-4896">
                    <div data-id="element-4897">
                      <p className="text-xs font-medium text-[#F5F5F5] mb-1" data-id="element-4898">
                        Freedom vs Structure
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-4899">2 occurrences</p>
                    </div>
                    <div data-id="element-4900">
                      <p className="text-xs font-medium text-[#F5F5F5] mb-1" data-id="element-4901">
                        Commitment vs Optionality
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-4902">1 occurrence</p>
                    </div>
                  </div>
                </div>

                {/* Phase */}
                <div className="border border-[#2B2B2B] bg-[#0A0A0A] p-4 sm:p-5" data-id="element-4903">
                  <p className="text-xs font-mono text-gray-600 uppercase tracking-wider mb-2" data-id="element-4904">
                    Phase
                  </p>
                  <p className="text-sm text-[#F5F5F5]" data-id="element-4905">Initial</p>
                </div>

                {/* Confidence */}
                <div className="border border-[#2B2B2B] bg-[#0A0A0A] p-4 sm:p-5" data-id="element-4906">
                  <p className="text-xs font-mono text-gray-600 uppercase tracking-wider mb-2" data-id="element-4907">
                    Confidence
                  </p>
                  <p className="text-sm text-[#F5F5F5]" data-id="element-4908">Low</p>
                </div>

                {/* View full system */}
                <Link to="/mirrors/work/result" className="block w-full p-4 border border-[#2B2B2B] text-center text-xs font-medium text-gray-400 hover:text-[#F5F5F5] hover:border-[#F5F5F5] transition-all" data-id="element-4909">
                  View Full System
                </Link>
              </div>
            </div>

            {/* Bottom info */}
            <div className="mt-8 sm:mt-10 pt-6 sm:pt-8 border-t border-[#2B2B2B]" data-id="element-4910">
              <p className="text-xs text-gray-600" data-id="element-4911">
                The mirror refines as you log. No analysis required.
              </p>
            </div>
          </div>
        </main>
      </div>
    </>;
}